<template>
  <div >
    <datepicker :state="datepickerState" ref="pickFrom" v-on:datepicker-date-picked="onDatePicked"></datepicker>
    
    <b-container fluid class="md-content">
         <b-row>
            <b-col cols="5">
            </b-col>
            <b-col cols="2" class="md-header">
                Schichten
            </b-col>
            <b-col cols="5">
                <b-button v-on:click="toggleDatePicker()">{{monthDisplay}}</b-button>
            </b-col>
        </b-row>
        <b-card no-body>
            <b-tabs card>
                <b-tab title="Schicht" active>
                    <b-row>
                        <b-col>
                            <b-button variant="success" @click="showModal('modal-createplanshift')">Schicht anlegen</b-button>
                        </b-col>
                            
                        <b-col>
                            <ShiftCreationWithTemplate @refreshShifts ="refresh"></ShiftCreationWithTemplate>
                        </b-col>
                        <b-col v-if="selectedShifts.length > 0">
                            <b-button variant="danger" @click="showModal('modal-deletemultishift')"> {{selectedShifts.length}} Schichten löschen</b-button>
                        </b-col>
                        <b-col v-if="selectedShifts.length > 0">
                            <b-button variant="warning" @click="showModal('modal-resetmultishift')"> {{selectedShifts.length}} Schichten leeren</b-button>
                        </b-col>
                        <b-col v-if="publishableShifts.length > 0">
                            <b-button variant="warning" @click="showModal('modal-publishmultishift')"> {{publishableShifts.length}} Schichten veröffentlichen</b-button>
                        </b-col>
                        <b-col v-if="unpublishableShifts.length > 0">
                            <b-button variant="warning" @click="showModal('modal-unpublishmultishift')"> {{unpublishableShifts.length}} Schichten unveröffentlichen</b-button>
                        </b-col>
                        <b-col>
                            <b-button variant="primary" @click="refresh()">Aktualisieren</b-button>
                        </b-col>
                    </b-row>
                    <br>
                    <b-row v-if="planshifts != undefined">
                        <b-col>
                            <b-table striped hover :borderless="true" :outlined="false" :items="planshifts" :fields="fields" selectable select-mode="range" @row-selected="updateSelectedShifts">
                                <template slot="published" slot-scope="row">
                                    <i v-bind:class="{'fas fa-check': row.item.published, 'fas fa-times': !row.item.published}"></i>
                                </template>
                                <template slot="from" slot-scope="row">
                                    {{getFormattedDateString(row.item.from)}}
                                </template>
                                <template slot="to" slot-scope="row">
                                    {{getFormattedDateString(row.item.to)}}
                                </template>
                                <template slot="publishDate" slot-scope="row">
                                    {{getFormattedDateString(row.item.publishDate)}}
                                </template>
                                <template slot="actions" slot-scope="row">
                                    <b-button class="mx-1" size="sm" variant="success" v-on:click="openPublishModal(row.item.id)" v-if="!row.item.published && row.item.employeeId != null"><i class="fas fa-arrow-alt-circle-up"></i></b-button>
                                    <b-button class="mx-1" size="sm" variant="warning" v-on:click="openUnpublishModal(row.item.id)" v-if="isUnpublishable(row.item)"><i class="fas fa-arrow-alt-circle-down"></i></b-button>
                                    <b-button class="mx-1" size="sm" v-on:click="openViewModal(row.item.id)"><i class="fas fa-eye"></i></b-button>
                                    <b-button class="mx-1" size="sm" v-on:click="openEditModal(row.item.id)" v-if="!row.item.published"><i class="fas fa-pencil-alt"></i></b-button>
                                    <b-button class="mx-1" size="sm" variant="danger" v-on:click="openDeleteModal(row.item.id)"><i class="fas fa-trash"></i></b-button>
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                </b-tab>
                <b-tab title="Schicht-Änderungen">
                    <b-row>
                        <b-col>
                            <b-button variant="primary" @click="refresh()">Aktualisieren</b-button>
                        </b-col>
                    </b-row>
                    <br>
                    <b-row v-if="shiftChanges != undefined">
                        <b-col>
                            <b-table striped hover :borderless="true" :outlined="false" :items="shiftChanges" :fields="shiftChangeTableFields">
                                <template slot="changes" slot-scope="row">
                                    <p v-for="item in row.item.changes" v-bind:key="item.label">{{item.label}}: {{item.newValue}}</p>
                                </template>
                                <template slot="approved" slot-scope="row">
                                    <i v-bind:class="{'fas fa-check': row.item.approved, 'fas fa-times': !row.item.approved}"></i>
                                </template>
                                <template slot="actions" slot-scope="row">
                                    <b-button class="mx-1" size="sm" variant="success" v-on:click="openApproveShiftChangeModal(row.item.id)"><i class="fas fa-check-circle"></i></b-button>
                                    <b-button class="mx-1" size="sm" variant="danger" v-on:click="openDeleteShiftChangeModal(row.item.id)"><i class="fas fa-trash"></i></b-button>
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                </b-tab>
            </b-tabs>
            
        </b-card>
    </b-container>

    <b-modal ref="modal-viewplanshift"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Schicht Detail" @cancel="hideModal('modal-viewplanshift')" @ok="hideModal('modal-viewplanshift')" cancel-title="Abbrechen">
        <b-container fluid>
         <b-card no-body>
            <b-tabs card>
                <b-tab title="Schicht" active>
                    <div v-if="planShiftMap[planShiftId] != undefined">
                        <b-row>
                            <b-col class="md-2">
                                <b>Position:</b> 
                            </b-col>
                            <b-col>
                                <p v-if="!$helpers.isBlank(planShiftMap[planShiftId].spotId)">{{spotMap[planShiftMap[planShiftId].spotId].name}}</p>
                            </b-col>
                            <b-col class="md-2">
                                <b>Mitarbeiter:</b> 
                            </b-col>
                            <b-col>
                                <p v-if="!$helpers.isBlank(planShiftMap[planShiftId].employeeId)">{{employeeMap[planShiftMap[planShiftId].employeeId].firstName}} {{employeeMap[planShiftMap[planShiftId].employeeId].lastName}}</P>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Von:</b> 
                            </b-col>
                            <b-col>
                                {{planShiftMap[planShiftId].from}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Bis:</b> 
                            </b-col>
                            <b-col>
                                {{planShiftMap[planShiftId].to}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Arbeitszeit-Wert:</b> 
                            </b-col>
                            <b-col>
                                {{planShiftMap[planShiftId].workValue}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Feiertags Arbeitszeit-Wert:</b> 
                            </b-col>
                            <b-col>
                                {{planShiftMap[planShiftId].holidayWorkValue}}
                            </b-col>
                        </b-row>
                        
                        
                    </div>
                </b-tab>

                <b-tab title="Skills">
                    <b-row class="my-1">
                        <b-col>
                            <b-button variant="success" @click="showModal('modal-createshiftskill')">Skill hinzufügen</b-button>
                        </b-col>
                    </b-row>
                    <div v-if="shiftSkills!= undefined">
                        <b-table striped hover :borderless="true" :outlined="false" :items="shiftSkills" :fields="shiftSkillTableFields">
                            <template slot="min" slot-scope="row">
                                    <p v-if="row.item.required">{{row.item.minValue}} </p>
                                    <p v-else>-</p>
                            </template>
                            <template slot="max" slot-scope="row">
                                    <p v-if="row.item.required">{{row.item.maxValue}} </p>
                                    <p v-else>-</p>
                            </template>
                            <template slot="actions" slot-scope="row">
                                <b-button class="mx-1" size="sm"><i class="fas fa-pencil-alt"></i></b-button>
                                <b-button class="mx-1" size="sm" variant="danger" v-on:click="openDeleteShiftSkillModal(row.item.id)"><i class="fas fa-trash"></i></b-button>
                            </template>
                        </b-table>
                    </div>
                    
                </b-tab>
            </b-tabs>
        </b-card>   
        </b-container>
    </b-modal>

    <b-modal ref="modal-createplanshift"  size="lg" scrollable no-close-on-backdrop no-close-on-esc centered title="Schicht anlegen" @cancel="hideModal('modal-createplanshift')" @ok="createPlanShift" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
            
                <b-form-group label-cols="4" label-cols-lg="4" label="Position" label-for="cs1">
                    <b-form-select id = "cs1" v-model="planShift.spotId">
                        <option v-bind:value="null">
                            Keine Position
                        </option>
                         <option v-for="option in spotMap" v-bind:key ="option.id" v-bind:value="option.id">
                            {{ option.name }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Mitarbeiter" label-for="cs2">
                    <b-form-select id = "cs2" v-model="planShift.employeeId">
                        <option v-bind:value="null">
                            Kein Mitarbeiter
                        </option>
                         <option v-for="option in employeeMap" v-bind:key ="option.id" v-bind:value="option.id">
                            {{ option.lastName }} {{ option.firstName }} 
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Datum von" label-for="cs3">
                    <b-form-input id="cs3" v-model="planShift.fromDate" type="date"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Uhrzeit von" label-for="cs4">
                    <b-form-input id="cs4" v-model="planShift.fromTime" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Datum bis" label-for="cs5">
                    <b-form-input id="cs5" v-model="planShift.toDate" type="date"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="24" label="Uhrzeit bis" label-for="cs6">
                    <b-form-input id="cs6" v-model="planShift.toTime" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Automatischer Zeitwert" label-for="cs7">
                    <b-form-checkbox id="cs7" v-model="planShift.calculateWorkValue">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Zeitwert (Minuten)" label-for="cs8" v-if="planShift.calculateWorkValue === false">
                    <b-form-input min="-1" id="cs8" v-model.number="planShift.workValue" type="number"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Automatischer Feiertags Zeitwert" label-for="cs9">
                    <b-form-checkbox id="cs9" v-model="planShift.calculateHolidayWorkValue">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Feiertags Zeitwert (Minuten)" label-for="cs10" v-if="planShift.calculateHolidayWorkValue === false">
                    <b-form-input min="-1" id="cs10" v-model.number="planShift.holidayWorkValue" type="number"></b-form-input>
                </b-form-group>
            </div>
            
            <b-row v-if="error">
                Fehler beim Erstellen der Schicht.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-editplanshift"  size="lg" scrollable no-close-on-backdrop no-close-on-esc centered title="Schicht bearbeiten" @cancel="hideModal('modal-editplanshift')" @ok="updatePlanShift" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
            
                <b-form-group label-cols="4" label-cols-lg="4" label="Position" label-for="us1">
                    <b-form-select id = "us1" v-model="planShiftUpdate.spotId">
                        <option v-bind:value="null">
                            Keine Position
                        </option>
                         <option v-for="option in spotMap" v-bind:key ="option.id" v-bind:value="option.id">
                            {{ option.name }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Mitarbeiter" label-for="us2">
                    <b-form-select id = "us2" v-model="planShiftUpdate.employeeId">
                        <option v-bind:value="null">
                            Kein Mitarbeiter
                        </option>
                         <option v-for="option in employeeMap" v-bind:key ="option.id" v-bind:value="option.id">
                            {{ option.lastName }} {{ option.firstName }} 
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Datum von" label-for="us3">
                    <b-form-input id="us3" v-model="planShiftUpdate.fromDate" type="date"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Uhrzeit von" label-for="us4">
                    <b-form-input id="us4" v-model="planShiftUpdate.fromTime" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Datum bis" label-for="us5">
                    <b-form-input id="us5" v-model="planShiftUpdate.toDate" type="date"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Uhrzeit bis" label-for="us6">
                    <b-form-input id="us6" v-model="planShiftUpdate.toTime" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Automatischer Zeitwert" label-for="us7">
                    <b-form-checkbox id="us7" v-model="planShiftUpdate.calculateWorkValue">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Zeitwert (Minuten)" label-for="us8" v-if="planShiftUpdate.calculateWorkValue === false">
                    <b-form-input min="-1" id="us8" v-model.number="planShiftUpdate.workValue" type="number"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Automatischer Feiertags Zeitwert" label-for="us9">
                    <b-form-checkbox id="us9" v-model="planShiftUpdate.calculateHolidayWorkValue">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Feiertags Zeitwert (Minuten)" label-for="us10" v-if="planShiftUpdate.calculateHolidayWorkValue === false">
                    <b-form-input min="-1" id="us10" v-model.number="planShiftUpdate.holidayWorkValue" type="number"></b-form-input>
                </b-form-group>
            </div>
            
            <b-row v-if="error">
                Fehler beim Erstellen der Schicht.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-createshiftskill"  size="lg" scrollable no-close-on-backdrop no-close-on-esc centered title="Schicht Skill anlegen" @cancel="hideModal('modal-createshiftskill')" @ok="createShiftSkill" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
            
                <b-form-group label-cols="4" label-cols-lg="4" label="Skill" label-for="css1">
                    <b-form-select id = "css1" v-model="shiftSkill.skillId">
                         <option v-for="option in skillMap" v-bind:key ="option.id" v-bind:value="option.id">
                            {{ option.name }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Verpflichtend" label-for="css2">
                    <b-form-checkbox id="css2" v-model="shiftSkill.required">
                    </b-form-checkbox>
                </b-form-group>

                <section v-if="shiftSkill.required">
                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Min. Skill Wert" label-for="ctfield16" :description="''+shiftSkill.minValue">
                            <b-form-input min="1" :max="shiftSkill.maxValue" id="ctfield16" v-model.number="shiftSkill.minValue" type="range"></b-form-input>
                    </b-form-group>
                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Max. Skill Wert" label-for="ctfield17" :description="''+shiftSkill.maxValue">
                            <b-form-input  :min="shiftSkill.minValue" max="100" id="ctfield17" v-model.number="shiftSkill.maxValue" type="range"></b-form-input>
                    </b-form-group>
                </section>

               
            </div>
            
            <b-row v-if="error">
                Fehler beim Erstellen der Schicht.
            </b-row>
        </b-container>
    </b-modal>

    
    <b-modal ref="modal-deleteplanshift"  no-close-on-backdrop no-close-on-esc centered title="Schicht löschen" @cancel="hideModal('modal-deleteplanshift')" @ok="deletePlanShift" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row class="my-1">
                <p> Sind Sie sicher dass Sie die Schicht löschen wollen?</p>
            </b-row>
            <b-row v-if="error" class="my-1">
                Fehler beim Löschen der Schicht.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-publishplanshift"  no-close-on-backdrop no-close-on-esc centered title="Schicht veröffentlichen" @cancel="hideModal('modal-publishplanshift')" @ok="publishPlanShift" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row class="my-1">
                <p> Sind Sie sicher dass Sie die Schicht veröffentlichen wollen?</p>
            </b-row>
            <b-row v-if="error" class="my-1">
                Fehler beim Veröffentlichen der Schicht.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-unpublishplanshift"  no-close-on-backdrop no-close-on-esc centered title="Schicht unveröffentlichen" @cancel="hideModal('modal-unpublishplanshift')" @ok="unpublishPlanShift" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row class="my-1">
                <p> Sind Sie sicher dass Sie die Schicht unveröffentlichen wollen?</p>
            </b-row>
            <b-row v-if="error" class="my-1">
                Fehler beim Unveröffentlichen der Schicht.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-approveshiftchange"  no-close-on-backdrop no-close-on-esc centered title="Schicht Änderung bestätigen" @cancel="hideModal('modal-approveshiftchange')" @ok="approveShiftChange" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row class="my-1">
                <p> Sind Sie sicher dass Sie die Schicht Änderung durchführen wollen?</p>
            </b-row>
            <b-row v-if="error" class="my-1">
                Fehler beim Durchführen der Schicht Änderung.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-deleteshiftchange"  no-close-on-backdrop no-close-on-esc centered title="Schicht Änderung löschen" @cancel="hideModal('modal-deleteshiftchange')" @ok="deleteShiftChange" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row class="my-1">
                <p> Sind Sie sicher dass Sie die Schicht Änderung entfernen wollen?</p>
            </b-row>
            <b-row v-if="error" class="my-1">
                Fehler beim Löschen der Schicht Änderung.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-deleteshiftskill"  no-close-on-backdrop no-close-on-esc centered title="Schicht Skill löschen" @cancel="hideModal('modal-deleteshiftskill')" @ok="deleteShiftSkill" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row class="my-1">
                <p> Sind Sie sicher dass Sie den Skill von der Schicht entfernen wollen?</p>
            </b-row>
            <b-row v-if="error" class="my-1">
                Fehler beim Löschen des Schicht Skills.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-deletemultishift"  size="lg" scrollable no-close-on-backdrop no-close-on-esc centered title="Mehrere Schichten löschen" @cancel="hideModal('modal-deletemultishift')" @ok="multiDeletePlanShift" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row class="my-1">
                <p> Sind Sie sicher dass Sie die {{selectedShifts.length}} Schichten entfernen wollen?</p>
            </b-row>
            
            <b-row v-if="error">
                Fehler beim Löschen der Schichten.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-resetmultishift"  size="lg" scrollable no-close-on-backdrop no-close-on-esc centered title="Mehrere Schichten leeren" @cancel="hideModal('modal-resetmultishift')" @ok="multiResetPlanShift" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row class="my-1">
                <p> Sind Sie sicher dass Sie von {{selectedShifts.length}} Schichten den Mitarbeiter entfernen wollen?</p>
            </b-row>
            
            <b-row v-if="error">
                Fehler beim Leeren der Schichten.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-publishmultishift"  size="lg" scrollable no-close-on-backdrop no-close-on-esc centered title="Mehrere Schichten veröffentlichen" @cancel="hideModal('modal-publishmultishift')" @ok="multiPublishPlanShift" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row class="my-1">
                <p> Sind Sie sicher dass Sie die {{publishableShifts.length}} Schichten veröffentlichen wollen?</p>
            </b-row>
            
            <b-row v-if="error">
                Fehler beim Veröffentlichen der Schichten.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-unpublishmultishift"  size="lg" scrollable no-close-on-backdrop no-close-on-esc centered title="Mehrere Schichten unveröffentlichen" @cancel="hideModal('modal-unpublishmultishift')" @ok="multiUnpublishPlanShift" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row class="my-1">
                <p> Sind Sie sicher dass Sie die {{unpublishableShifts.length}} Schichten unveröffentlichen wollen?</p>
            </b-row>
            
            <b-row v-if="error">
                Fehler beim Unveröffentlichen der Schichten.
            </b-row>
        </b-container>
    </b-modal>
    

  </div>

</template>

<script>

import ShiftCreationWithTemplate from './ShiftCreationWithTemplate.vue';
import datepicker from '../uicomponents/datepicker.vue'
export default {
  name: 'planshift',
  components: {
      datepicker,
      ShiftCreationWithTemplate,
  },
  data () {
    return {
      selectedShifts: [],
      spotMap: {},
      skillMap: {},
      shiftSkillMap:{},
      employeeMap: {},
      planShiftMap: {},
      shiftChangeMap: {},
      shiftChanges: [],
      planshifts: [],
      shiftSkills: [],
      shiftDeletionStartDate: null,
      shiftDeletionEndDate: null,
      fields: [{key:"spot", label:"Position", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'},{key:"employee", label:"Mitarbeiter", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'}, {key:"from", label:"Von", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'},{key:"to", label:"Bis", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'},
               {key:"publishDate", label:"Publikations Datum", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'},{key:"published", label:"Publiziert", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'},{key:"actions", label: "", sortable: false}],
      shiftSkillTableFields: [{key:"skill", label:"Skill", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'},{key:"required", label:"Verpflichtend", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'},{key:"min", label:"Min. Wert", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'}, {key:"max", label:"Max. Wert", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'},{key:"actions", sortable: false}],
      shiftChangeTableFields: [{key:"changeDate", label:"Änderungsdatum", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'},{key:"spot", label:"Position", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'},{key:"employee", label:"Mitarbeiter", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'}, {key:"from", label:"Von", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'},
                               {key:"to", label:"Bis", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'},{key:"approved", label:"Bestätigt", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'},{key:"changes", label:"Änderungen", sortable: true, thClass: 'documentsTh', tdClass: 'documentsTd'},{key:"actions", sortable: false}],
      planShift: {
          employeeId: null,
          spotId: null,
          fromDate: null,
          toDate: null,
          fromTime: null,
          toTime: null,
          workValue: -1,
          holidayWorkValue: -1,
          calculateWorkValue: true,
          calculateHolidayWorkValue: true,
          
      },
      planShiftUpdate: {
          employeeId: null,
          spotId: null,
          fromDate: null,
          toDate: null,
          fromTime: null,
          toTime: null,
          workValue: -1,
          holidayWorkValue: -1,
          calculateWorkValue: true,
          calculateHolidayWorkValue: true,
      },
      shiftSkill: {
          skillId: null,
          required: false,
          minValue: 1,
          maxValue: 100,
      },
      planShiftId:"",
      shiftSkillId: "",
      shiftChangeId: "",
      error: false,
      dateSelectionStart: this.$helpers.getCurrentMonthMomentUTC(),
      datepickerState: {
            toggled: false,
            monthView: true,
            yearViewAllowed: false,
            dayViewAllowed: false,
            posx: window.mouse.x,
            posy: window.mouse.y,
            date: this.$helpers.getCurrentMonthMomentUTC(),
            selectedDate: this.$helpers.getCurrentMonthMomentUTC()
      },
      loading: false
      
    }
  },
  created: function () {
        if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
            this.refresh();
        }
  },
  computed: {
        publishableShifts() {
            return this.selectedShifts.filter(s =>!s.published && s.employeeId != null);
        },
        unpublishableShifts() {
            
            return this.selectedShifts.filter(s =>this.isUnpublishable(s));
        },
        rosterFromTo() {
            if(this.$store.state.loggedIn){
                return this.$store.state.rosterFromTo;
            } else {
                return null;
            }    
        },
        storeId() {
            return this.$store.state.storeId;
        },
        monthDisplay: function() {
            if(this.dateSelectionStart != null){
                return this.dateSelectionStart.format('MMM YYYY');
            } else {
                '-';
            }
                
        },
  },
  watch: { 
    rosterFromTo(newVal, oldVal) {
        if(newVal != null && this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
            this.refresh();
        }
    },
    storeId(newVal, oldVal) {
        console.log("Changed storeId: "+newVal);
        this.refresh();
    }
  },
  // methods that implement data logic.
  methods: {
    toggleDatePicker() {
        
        this.datepickerState = {
            toggled: true,
            monthView: true,
            yearViewAllowed: false,
            dayViewAllowed: false,
            posx: window.mouse.x,
            posy: window.mouse.y,
            date: this.dateSelectionStart,
            selectedDate: this.dateSelectionStart
        };
    },
    setDateSelection(date, calculateRosterFromTo){
        this.dateSelectionStart = date.clone(); 
                
        if(calculateRosterFromTo){
            //update vuex store with calculated from to => triggers reload of data via refresh
            
            let rosterFromTo = {
                month: this.dateSelectionStart.month(),
                from: this.dateSelectionStart.clone().startOf('isoWeek').format(),
                to: this.dateSelectionStart.clone().endOf('month').endOf('isoWeek').add(1,'weeks').startOf('isoWeek').format(),
            };
            this.$store.commit('setRosterFromTo', {rosterFromTo: rosterFromTo});
        } else {
            //dont update vuex from to, only update client side view
        }
    },
    onDatePicked(date){        
        this.setDateSelection(date, true);
    },
    refresh: function(){
        if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined && !this.loading){
            let view = this;
            this.loading = true;
            this.loadSpots()
            .then(response => {
                view.updateSpots(response.data);
                return view.loadSkills();
            }).then(response => {
                view.updateSkills(response.data);
                return this.loadEmployees();
            }).then(response => {
                view.updateEmployees(response.data);
                return this.loadPlanshifts();
            }).then(response => {
                view.updatePlanshifts(response.data);
                return this.loadShiftSkills();
            }).then(response => {
                view.updateShiftSkills(response.data);
                return view.loadShiftChanges();
                
            }).then(response => {
                view.updateShiftChanges(response.data);
                view.loading = false;
            }).catch(function (error) {
                view.loading = false;
                console.log(error);
            })
        }
        

       
    },
    updateSelectedShifts(items) {
        this.selectedShifts = items
    },
    isUnpublishable(item){
        return item.published && this.$helpers.getMomentFromString(item.from).diff(this.$helpers.getMomentUTC(), 'minutes') > 30
    },
    createPlanShift: function(evt){
        evt.preventDefault();
        this.error=false;
        let view = this;
        let url = '/api/sec/planshift';
        let params = {
            storeId: this.$store.state.storeId
        }

        let payload = {
          storeId: this.$store.state.storeId,
          skillMultiplier: 1,
          workValueMultiplier:1
        }
        console.log(this.planShift.fromDate);
        payload.from = this.$helpers.convertDateTimeString(this.planShift.fromDate, this.planShift.fromTime);
        payload.to = this.$helpers.convertDateTimeString(this.planShift.toDate, this.planShift.toTime);
        if(!this.$helpers.isBlank(this.planShift.employeeId)){
            payload.employeeId = this.planShift.employeeId
        }
        if(!this.$helpers.isBlank(this.planShift.spotId)){
            payload.spotId = this.planShift.spotId
        }
        if(this.planShift.calculateWorkValue){
            payload.workValue = -1;
        } else {
            payload.workValue = this.planShift.workValue;
        }

        if(this.planShift.calculateHolidayWorkValue){
            payload.holidayWorkValue = -1;
        } else {
            payload.holidayWorkValue = this.planShift.holidayWorkValue;
        }

        this.axios({
            method: 'post',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
           
            let planShiftItem = response.data.data;
            if(!view.$helpers.isBlank(response.data.data.employeeId)){
                planShiftItem.employee = view.employeeMap[response.data.data.employeeId].firstName+" "+view.employeeMap[response.data.data.employeeId].lastName;
            } else {
                planShiftItem.employee = "";
            }
            if(!view.$helpers.isBlank(response.data.data.spotId)){
                planShiftItem.spot = view.spotMap[response.data.data.spotId].name;
            } else {
                planShiftItem.spot = "";
            }
            view.planShiftMap[response.data.data.id] = response.data.data;
            view.planshifts.push(planShiftItem);
            
            
            view.hideModal('modal-createplanshift');
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },
    updatePlanShift: function(evt){
        evt.preventDefault();
        this.error=false;
        let view = this;
        let url = '/api/sec/planshift';
        let params = {
            storeId: this.$store.state.storeId
        }

        let payload = {
          storeId: this.$store.state.storeId,
          id: this.planShiftId,
          updateFields: []
        }
        let ofrom = this.$helpers.convertDateTimeString(this.planShift.fromDate, this.planShift.fromTime);
        let cfrom = this.$helpers.convertDateTimeString(this.planShiftUpdate.fromDate, this.planShiftUpdate.fromTime);
        if(ofrom != cfrom){
            payload.from = cfrom;
            payload.updateFields.push("from");
        }
        let oto = this.$helpers.convertDateTimeString(this.planShift.toDate, this.planShift.toTime);
        let cto = this.$helpers.convertDateTimeString(this.planShiftUpdate.toDate, this.planShiftUpdate.toTime);
        if(oto != cto){
            payload.to = cto;
            payload.updateFields.push("to");
        }
        if(this.planShift.employeeId != this.planShiftUpdate.employeeId){
            payload.employeeId = this.planShiftUpdate.employeeId;
            payload.updateFields.push("employeeId");
        }
        if(this.planShift.spotId != this.planShiftUpdate.spotId){
            payload.spotId = this.planShiftUpdate.spotId;
            payload.updateFields.push("spotId");
        }
        if(this.planShift.calculateWorkValue != this.planShiftUpdate.calculateWorkValue){
            if(this.planShiftUpdate.calculateWorkValue){
                payload.workValue = -1;
            } else {
                payload.workValue = this.planShiftUpdate.workValue;
            }
            payload.updateFields.push("workValue");
        } else if(!this.planShiftUpdate.calculateWorkValue && this.planShift.workValue != this.planShiftUpdate.workValue){
            payload.workValue = this.planShiftUpdate.workValue;
            payload.updateFields.push("workValue");
            
        }

        if(this.planShift.calculateHolidayWorkValue != this.planShiftUpdate.calculateHolidayWorkValue){
            if(this.planShiftUpdate.calculateHolidayWorkValue){
                payload.holidayWorkValue = -1;
            } else {
                payload.holidayWorkValue = this.planShiftUpdate.holidayWorkValue;
            }
            payload.updateFields.push("holidayWorkValue");
        } else if(!this.planShiftUpdate.calculateHolidayWorkValue && this.planShift.holidayWorkvalue != this.planShiftUpdate.holidayWorkvalue){
            payload.holidayWorkValue = this.planShiftUpdate.holidayWorkvalue;
            payload.updateFields.push("holidayWorkValue");
            
        }
        
        this.axios({
            method: 'put',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.refresh();
            view.hideModal('modal-editplanshift');
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },
    publishPlanShift: function(evt){
        evt.preventDefault();
        this.error=false;
        let view = this;
        let url = '/api/sec/planshift/publish';
        let params = {
            storeId: this.$store.state.storeId
        }
       
        let payload = {id: this.planShiftId};
        
        this.axios({
            method: 'put',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            const index = this.planshifts.findIndex(planshift => planshift.id === view.planShiftId) 
            
            view.planshifts[index].published=true;
            view.planShiftMap[view.planShiftId].published = true;
              
            view.hideModal('modal-publishplanshift');
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },
    unpublishPlanShift: function(evt){
        evt.preventDefault();
        this.error=false;
        let view = this;
        let url = '/api/sec/planshift/unpublish';
        let params = {
            storeId: this.$store.state.storeId
        }
       
        let payload = {id: this.planShiftId};
        
        this.axios({
            method: 'put',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            const index = this.planshifts.findIndex(planshift => planshift.id === view.planShiftId) 
            
            view.planshifts[index].published=false;
            view.planShiftMap[view.planShiftId].published = false;
              
            view.hideModal('modal-unpublishplanshift');
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },
    deletePlanShift: function(evt){
        evt.preventDefault();
        this.error=false;
        let view = this;
        let url = '/api/sec/planshift';
        
        let params = {
            storeId: this.$store.state.storeId,
            id: this.planShiftId,
        }
        
        
        this.axios({
            method: 'delete',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            const index = this.planshifts.findIndex(planshift => planshift.id === view.planShiftId) 
            if (~index) {
                view.planshifts.splice(index, 1);
            }
            view.deletePlanShiftFromMap(view.planShiftId);   
            view.hideModal('modal-deleteplanshift');
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },
    getFormattedDateString(str){
        if(str){
             return this.$helpers.getMomentFromStringUTC(str).format("DD.MM.YYYY HH:mm");
        } else {
            return "-";
        }
       
    },
    multiResetPlanShift: function(evt){
        evt.preventDefault();
        this.error=false;
        let view = this;
        let url = '/api/sec/planshift/multi';
        
       
        let params = {
            storeId: this.$store.state.storeId
        }
        
        let payload = {requests: []};
        this.selectedShifts.forEach(item => payload.requests.push({id: item.id, updateFields: ["employeeId"], employeeId: null}));
        
        this.axios({
            method: 'put',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {

            view.refresh();
            view.hideModal('modal-resetmultishift'); 
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },
    multiDeletePlanShift: function(evt){
        evt.preventDefault();
        this.error=false;
        let view = this;
        let url = '/api/sec/planshift/any/delete';
        
       
        let params = {
            storeId: this.$store.state.storeId
        }
        
        let payload = {ids: []};
        this.selectedShifts.forEach(item => payload.ids.push(item.id));
        
        this.axios({
            method: 'post',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {

            view.refresh();
            view.hideModal('modal-deletemultishift'); 
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },
     multiPublishPlanShift: function(evt){
        evt.preventDefault();
        this.error=false;
        let view = this;
        let url = '/api/sec/planshift/publish/multi';
        let params = {
            storeId: this.$store.state.storeId
        }
        
        let payload = {ids: []};
        this.publishableShifts.forEach(item => payload.ids.push(item.id));
        
        this.axios({
            method: 'put',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {

            view.refresh();
            view.hideModal('modal-publishmultishift'); 
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },
    multiUnpublishPlanShift: function(evt){
        evt.preventDefault();
        this.error=false;
        let view = this;
        let url = '/api/sec/planshift/unpublish/multi';
        let params = {
            storeId: this.$store.state.storeId
        }
        
        let payload = {ids: []};
        this.unpublishableShifts.forEach(item => payload.ids.push(item.id));
        
        this.axios({
            method: 'put',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {

            view.refresh();
            view.hideModal('modal-unpublishmultishift'); 
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },
    approveShiftChange: function(evt){
        evt.preventDefault();
        this.error=false;
        let view = this;
        let url = '/api/sec/shiftchange';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/shiftchange');
       
        let payload = {id: this.shiftChangeId};
        
        this.axios({
            method: 'put',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            view.refresh();
              
            view.hideModal('modal-approveshiftchange');
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },
    deleteShiftChange: function(evt){
        evt.preventDefault();
        this.error=false;
        let view = this;
        let url = '/api/sec/shiftchange';
        
        url = this.$helpers.appendParam("id", this.shiftChangeId, url, '/api/sec/shiftchange');
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/shiftchange');
       
        
        this.axios({
            method: 'delete',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            const index = this.shiftChanges.findIndex(shiftChange => shiftChange.id === view.shiftChangeId) 
            if (~index) {
                view.shiftChanges.splice(index, 1);
            }
            view.deleteShiftChangeFromMap(view.shiftChangeId);   
            view.hideModal('modal-deleteshiftchange');
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },
    openViewModal: function(id){
        
        this.planShiftId = id;
      
        this.shiftSkills = [];
        for(var p in this.shiftSkillMap){
            if(this.shiftSkillMap[p].shiftId === this.planShiftId){
                let shiftSkillEntry ={
                    id: this.shiftSkillMap[p].id,
                    required: this.shiftSkillMap[p].required,
                    skill: this.skillMap[this.shiftSkillMap[p].skillId].name,
                    minValue: this.shiftSkillMap[p].minValue,
                    maxValue: this.shiftSkillMap[p].maxValue
                }
                this.shiftSkills.push(shiftSkillEntry);
            }
        }
        
        this.showModal('modal-viewplanshift');
    },
    openEditModal: function(id){
        
        this.planShiftId = id;
        let shift = this.planShiftMap[this.planShiftId];
        
        if(!this.$helpers.isBlank(shift.employeeId)){
            this.planShift.employeeId = shift.employeeId;
            this.planShiftUpdate.employeeId = shift.employeeId;
        }
       
        if(!this.$helpers.isBlank(shift.spotId)){
            this.planShift.spotId = shift.spotId;
            this.planShiftUpdate.spotId = shift.spotId;
        }
        if(!this.$helpers.isBlank(shift.workValue)){
            if(shift.workValue === -1){
                this.planShift.calculateWorkValue = true;
                this.planShiftUpdate.calculateWorkValue = true;
            } else {
                this.planShift.calculateWorkValue = false;
                this.planShiftUpdate.calculateWorkValue = false;
            }
            this.planShift.workValue = shift.workValue;
            this.planShiftUpdate.workValue = shift.workValue;
        }
        if(!this.$helpers.isBlank(shift.holidayWorkValue)){
            if(shift.workValue === -1){
                this.planShift.calculateHolidayWorkValue = true;
                this.planShiftUpdate.calculateHolidayWorkValue = true;
            } else {
                this.planShift.calculateHolidayWorkValue = false;
                this.planShiftUpdate.calculateHolidayWorkValue = false;
            }
            this.planShift.holidayWorkValue = shift.holidayWorkValue;
            this.planShiftUpdate.holidayWorkValue = shift.holidayWorkValue;
        }
        if(!this.$helpers.isBlank(shift.from)){
            let fromDate = this.$helpers.extractDateString(shift.from);
            let fromTime = this.$helpers.extractDateString(shift.from, 'HH:mm');
            this.planShift.fromDate = fromDate ;
            this.planShiftUpdate.fromDate = fromDate ;
            this.planShift.fromTime = fromTime ;
            this.planShiftUpdate.fromTime = fromTime ;
        }
         if(!this.$helpers.isBlank(shift.to)){
            let toDate = this.$helpers.extractDateString(shift.to);
            let toTime = this.$helpers.extractDateString(shift.to, 'HH:mm');
            this.planShift.toDate = toDate ;
            this.planShiftUpdate.toDate = toDate ;
            this.planShift.toTime = toTime ;
            this.planShiftUpdate.toTime = toTime ;
        }
        
        this.showModal('modal-editplanshift');
    },
    openModal: function(id, modalname){

        this.planShiftId = id;
        this.showModal(modalname);
    },
    openPublishModal: function(id){
        this.planShiftId = id;
        this.showModal('modal-publishplanshift');
    },
    openUnpublishModal: function(id){
        this.planShiftId = id;
        this.showModal('modal-unpublishplanshift');
    },
    openDeleteShiftSkillModal: function(id){
        this.shiftSkillId = id;
        this.showModal('modal-deleteshiftskill');
    },
    openDeleteShiftChangeModal: function(id){
        this.shiftChangeId = id;
        this.showModal('modal-deleteshiftchange');
    },
    openApproveShiftChangeModal: function(id){
        this.shiftChangeId = id;
        this.showModal('modal-approveshiftchange');
    },
    createShiftSkill: function(evt){
        evt.preventDefault();
        this.error= false;
        let view = this;
        let url = '/api/sec/shiftskillrequirement';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/shiftskillrequirement');

        let payload = {
          shiftId: this.planShiftId
        }
        payload.skillId = this.shiftSkill.skillId;
        payload.required = this.shiftSkill.required;
        if(payload.required){
            payload.minValue = this.shiftSkill.minValue;
            payload.maxValue = this.shiftSkill.maxValue;
        } else {
            payload.minValue = 1;
            payload.maxValue = 100;
        }
        
        this.axios({
            method: 'post',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            console.log(response)
            let shiftSkillItem = {
                id: response.data.data.id,
                required: response.data.data.required,
                skill: view.skillMap[response.data.data.skillId].name,
                minValue: response.data.data.minValue,
                maxValue: response.data.data.maxValue
            }
            
            view.shiftSkillMap[response.data.data.id] = response.data.data;
            view.shiftSkills.push(shiftSkillItem);
            
            
            view.hideModal('modal-createshiftskill');
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },
    deleteShiftSkill: function(evt){
        evt.preventDefault();
        this.error=false;
        let view = this;
        let url = '/api/sec/shiftskillrequirement';
        
        url = this.$helpers.appendParam("id", this.shiftSkillId, url, '/api/sec/shiftskillrequirement');
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/shiftskillrequirement');
        
        
        this.axios({
            method: 'delete',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            const index = this.shiftSkills.findIndex(shiftskill => shiftskill.id === view.shiftSkillId) 
            if (~index) {
                view.shiftSkills.splice(index, 1);
            }
            view.deleteShiftSkillFromMap(view.shiftSkillId);   
            view.hideModal('modal-deleteshiftskill');
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })

    },
    loadSpots : function() {
      
      let url = '/api/sec/spot';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/spot');
      

      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    loadSkills : function() {
      
      let url = '/api/sec/skill';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/skill');
     

      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    loadShiftSkills : function() {
      
      let url = '/api/sec/shiftskillrequirement';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/shiftskillrequirement');
     

      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    loadShiftChanges : function() {
      
      let url = '/api/sec/shiftchange';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/shiftchange');
      

      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    loadEmployees : function() {
      
      let url = '/api/sec/employee';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employee');

      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
			
    },
    updateSpots: function(data){
        var i;
        let tspots = {}
        for (i = 0; i < data.length; i++) { 
            tspots[data[i].id] =data[i];
        }
        this.spotMap = tspots;
    },
    updateEmployees: function(data){
        var i;
        let temployees = {}
        for (i = 0; i < data.length; i++) {
            temployees[data[i].id] =data[i];
        }
        this.employeeMap = temployees;
    },
    updateShiftChanges: function(data){
        var i;
        let tshiftchanges = {}
        let overviewB = [];
        for (i = 0; i < data.length; i++) {
            tshiftchanges[data[i].id] =data[i];
            overviewB.push(this.createShiftChangeItem(data[i]));
        }
        this.shiftChangeMap = tshiftchanges;
        this.shiftChanges = overviewB;
    },
    createShiftChangeItem: function(data){
        let item = {id: data.id, approved: data.approved, approvedBy: data.approvedBy, changeDate: this.$helpers.extractDateString(data.changeDate,'DD.MM.YYYY HH:mm'), responsible: data.responsible};
        item.from = this.planShiftMap[data.shiftId].from;
        item.to = this.planShiftMap[data.shiftId].to;
        if(!this.$helpers.isBlank(this.planShiftMap[data.shiftId].spotId)){
            item.spot = this.spotMap[this.planShiftMap[data.shiftId].spotId].name;
        } else {
            item.spot = "";
        }
        if(!this.$helpers.isBlank(this.planShiftMap[data.shiftId].employeeId)){
            item.employee = this.employeeMap[this.planShiftMap[data.shiftId].employeeId].firstName+" "+this.employeeMap[this.planShiftMap[data.shiftId].employeeId].lastName;
        } else {
            item.employee = "";
        }
        let changes = [];
        let change = {};
        if(data.changeDelta.employeeId != undefined){
            change.label="Mitarbeiter";
            if(this.$helpers.isBlank(data.changeDelta.employeeId)){
                change.newValue = "Kein Mitarbeiter";
            } else {
                change.newValue = this.employeeMap[data.changeDelta.employeeId].firstName + " " + this.employeeMap[data.changeDelta.employeeId].lastName
            }
            changes.push(change);
        }
        change = {};
        if(data.changeDelta.spotId != undefined){
            change.label="Position";
            if(this.$helpers.isBlank(data.changeDelta.spotId)){
                change.newValue = "Keine Position";
            } else {
                change.newValue = this.spotMap[data.changeDelta.spotId].name
            }
            changes.push(change);
        }
        change = {};
        if(data.changeDelta.from != undefined){
            change.label="Von";
            change.newValue = data.changeDelta.from;
            
            changes.push(change);
        }
        change = {};
        if(data.changeDelta.to != undefined){
            change.label="Bis";
            change.newValue = data.changeDelta.to;
            changes.push(change);
        }
        change = {};
        if(data.changeDelta.tasks != undefined){
            change.label="Aufgaben";
            change.newValue = data.changeDelta.tasks;
            changes.push(change);
        }
        item.changes = changes;
        return item;

    },
    updateSkills: function(data){
        var i;
        let tskills = {}
        for (i = 0; i < data.length; i++) {
            tskills[data[i].id] =data[i];
        }
        this.skillMap = tskills;
    },
    updateShiftSkills: function(data){
        var i;
        let tskills = {}
        for (i = 0; i < data.length; i++) {
            tskills[data[i].id] =data[i];
        }
        this.shiftSkillMap = tskills;
    },
    deletePlanShiftFromMap(id){
       
        for(var p in this.shiftSkillMap){
            if(this.shiftSkillMap[p].shiftId === id){
                this.deleteShiftSkillFromMap(p);
            }
        }
        for(var p2 in this.shiftChangeMap){
            if(this.shiftChangeMap[p2].shiftId === id){
                this.deleteShiftChangeFromMap(p2);
            }
        }
        
        delete this.planShiftMap[id];
    },
    deleteShiftSkillFromMap(id){
        delete this.shiftSkillMap[id]
    },
    deleteShiftChangeFromMap(id){
        delete this.shiftChangeMap[id]
    },
    loadPlanshifts : function() {
     
      let url = '/api/sec/planshift';

      
      
      let params = {
            storeId: this.$store.state.storeId,
            from: this.$store.state.rosterFromTo.from,
            to: this.$store.state.rosterFromTo.to,
      }

      return this.axios({
        method: 'get',
        params: params,
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
			
    },
    updatePlanshifts: function(data) {
        let overviewA = [];
        var i;
        for (i = 0; i < data.length; i++) {
            this.planShiftMap[data[i].id] = data[i]; 
            let planShiftItem = data[i];
            if(!this.$helpers.isBlank(data[i].employeeId)){
                planShiftItem.employee = this.employeeMap[data[i].employeeId].firstName+" "+this.employeeMap[data[i].employeeId].lastName;
            } else {
                planShiftItem.employee = "";
            }
            if(!this.$helpers.isBlank(data[i].spotId)){
                planShiftItem.spot = this.spotMap[data[i].spotId].name;
            } else {
                planShiftItem.spot = "";
            }
            overviewA.push(planShiftItem);
        }
      
        this.planshifts = overviewA;
    },
    hideModal (ref) {
        this.error = false;
        this.planShift = {
          employeeId: null,
          spotId: null,
          fromDate: null,
          toDate: null,
          fromTime: null,
          toTime: null,
          workValue: -1,
          holidayWorkValue: -1,
          calculateWorkValue: true,
          calculateHolidayWorkValue: true
          
        };
        this.planShiftUpdate = {
          employeeId: null,
          spotId: null,
          fromDate: null,
          toDate: null,
          fromTime: null,
          toTime: null,
          workValue: -1,
          holidayWorkValue: -1,
          calculateWorkValue: true,
          calculateHolidayWorkValue: true
        };
        this.shiftSkill = {
          skillId: null,
          required: false,
          minValue: 1,
          maxValue: 100,
        };
        this.$refs[ref].hide()
    },
    showModal(ref) {
        this.$refs[ref].show()
    }
  },
  

}
</script>

<!-- Add "scoped" attrispotte to limit CSS to this component only -->
<style scoped>

</style>
